export default __webpack_public_path__ + "static/youre-still-the-one-3b7a0772ce76f1ae2aab461a8069420f.jpg";